import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import AttachmentPreferencesChoiceGroup from './AttachmentPreferencesChoiceGroup';
var AttachmentPreferencesFull = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesFull, _super);
    function AttachmentPreferencesFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttachmentPreferencesFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var fromComputerSelectedKey = getFallbackValueIfNull(optionStore.fromComputer, userOptions.AttachOrShareLocalFiles);
        var fromOneDriveSelectedKey = getFallbackValueIfNull(optionStore.fromOneDrive, userOptions.AttachOrShareCloudFiles);
        return (React.createElement("div", null,
            React.createElement(AttachmentPreferencesChoiceGroup, { selectedKey: fromComputerSelectedKey, label: strings.options_attachmentPreferences_localLabel, optionKey: "fromComputer" }),
            React.createElement(AttachmentPreferencesChoiceGroup, { selectedKey: fromOneDriveSelectedKey, label: strings.options_attachmentPreferences_cloudLabel, optionKey: "fromOneDrive" })));
    };
    AttachmentPreferencesFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().ViewStateConfiguration; },
        })
    ], AttachmentPreferencesFull);
    return AttachmentPreferencesFull;
}(React.Component));
export default AttachmentPreferencesFull;
//# sourceMappingURL=AttachmentPreferencesFull.js.map